<div class="flex items-center"></div>

<div class="flex flex-col w-full">
  @if (unitEntryResource.isLoading()) {
  <soft-ds-loading-skeleton [height]="'6rem'" />
  } @else {
  <soft-ds-quantity-input
    [size]="'xl'"
    [value]="inputAmount()?.quantity ?? quantity() ?? 1"
    [float]="true"
    [disabled]="quantityInputDisabled()"
    (valueChange)="onQuantityChange($event)"
    [unit]="inputAmount()?.unit?.arteh ?? null"
  />
  }

  <!-- Unit Entry details -->
  @if (unitEntryEnabled()) {
  <div class="flex items-center justify-evenly">
    <div class="flex flex-col gap-2">
      <span class="text-sm inline-block whitespace-nowrap text-light shrink-0 mt-2">
        = {{ amount().quantity | number: '1.0-3' }} {{ amount()?.unit?.arteh }}
      </span>
    </div>

    @if (strategy().enabled()) {
    <div class="flex items-center w-full justify-end text-right mt-1.5">
      <soft-ds-button (click)="openUnitEntryModal()">Mengeneingabe</soft-ds-button>
    </div>
    }
  </div>
  }
</div>
